import React from "react"
import * as moment from "moment";
import { useState } from "react";
import { useEffect } from "react";

const DisplayLogs = ({ items }) => {
    
    return (
        <div className="row log-content-styles">
            {items?.releaseOrderRequest &&
             <div style={{minWidth: '300px'}}>
                  <div className="col-6 mb-2" style={{ display: 'grid' }}>
                 <p>Release Date</p>                
                 <p>{moment(items.releaseOrderRequest.releaseEpochDate * 1000).format('MM/DD/YYYY')}</p>
             </div>
                <div className="col-6 mb-2" style={{ display: 'grid' }}>
                 <p> Release Reason</p>
                 <p >{items.releaseOrderRequest.releaseReason.charAt(0).toUpperCase()}{items.releaseOrderRequest.releaseReason.slice(1) }</p>
             </div>
           
             
         </div>
            }
            {!items.releaseOrderRequest && <p style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>No logs found</p>}
        </div>
    )
}

export default DisplayLogs